import { BaseRepository } from "repositories/BaseRepository";

export class EventsRepository extends BaseRepository {
  constructor(db) {
    super(db, "events");
  }

  getByLineIdChatId(lineId, chatId) {
    return this.tx("readonly", (store) => {
      return new Promise((resolve, reject) => {
        const index = store.index("lineId_chatId");
        const request = index.getAll([lineId, chatId]);

        request.onsuccess = () => resolve(request.result || []);
        request.onerror = reject;
      });
    });
  }
}
